<div class="file-details-wrapper">
  <div class="file-details-content">
    <h1>{{$Locale.get("file/title")}}</h1>
    <div class="breadcrumbs-wrapper">
      <lib-breadcrumbs [steps]="breadcrumbsSteps"></lib-breadcrumbs>
      <button *ngIf="data && data.details.retry" mat-stroked-button (click)="retry()">
        <mat-icon>refresh</mat-icon>{{$Locale.get("file/retry")}}
      </button>
    </div>
    <div class="panel-wrapper">
      <h3 class="panel-title">{{$Locale.get("file/summary")}}</h3>
      <div class="panel-content">
        <app-details-panel *ngIf="data && data.details" [items]="detailsItems" [columns]="2" rows="3"></app-details-panel>
        <p *ngIf="data && (data.details | json) == '{}'" class="empty-data-title">
          <mat-icon>error_outline</mat-icon>
          {{$Locale.get("file/no_details")}}
        </p>
      </div>
    </div>
    <div class="panel-wrapper">
      <h3 class="panel-title">{{$Locale.get("file/brokers")}}</h3>
      <div class="table-wrapper">
        <app-brokers-table *ngIf="data && data.agents.length > 0" (rowClick)="handleRowClick($event)" [data]="data.agents"></app-brokers-table>
        <p *ngIf="data && !data.agents.length" class="empty-data-title">
          <mat-icon>error_outline</mat-icon>
          {{$Locale.get("file/no_brokers")}}
        </p>
      </div>
    </div>
    <div class="panel-wrapper">
      <h3 class="panel-title">{{$Locale.get("file/errors")}}</h3>
      <div class="table-wrapper">
        <app-errors-table *ngIf="data && data.errors.length > 0" [data]="data && data.errors"></app-errors-table>
        <p *ngIf="data && !data.errors.length" class="empty-data-title panel-content">
          <mat-icon>error_outline</mat-icon>
          {{$Locale.get("file/no_errors")}}
        </p>
      </div>
    </div>
  </div>
</div>